import React from "react";
import * as Yup from "yup";
import CadastroPadrao from "../../../Components/Common/CadastroPadrao";

import {
  getTiposEspaco,
  addNewTipoEspaco,
  updateTipoEspaco,
  deleteTipoEspaco
} from "../../../slices/api/tipoEspaco";

const TipoEspaco = () => {
  return (
  <CadastroPadrao
  titulo="Tipos de Espaço"
  labelSingular="Tipo de Espaço"
  reduxKey="tiposEspaco"
  acoesRedux={{
    onGet: getTiposEspaco,
    onAddNew: addNewTipoEspaco,
    onUpdate: updateTipoEspaco,
    onDelete: deleteTipoEspaco,
  }}
  colunas={[
    { campo: "id", titulo: "Código" },
    { campo: "nome", titulo: "Nome" },
    { campo: 'permite_locacao', titulo: 'Permite locação?' } 
  ]}
  camposFormulario={[
    {
      nome: "nome",
      label: "Nome",
      placeholder: "Informe o nome do tipo de espaço",
      validacao: Yup.string().required("Informe o nome do tipo de espaço"),
    },
    {
      nome: 'permite_locacao',
      label: 'Permite locação?',
      placeholder: 'Este espaço pode ser locado?',
      tipo: 'checkbox',
      validacao: Yup.boolean() // Validação opcional
    }
  ]}
/>
);
};

export default TipoEspaco;